export { default as HubsMultiSelect } from './hubs-multi-select';
